export class AuthorProfilePage {
    private static instance: AuthorProfilePage | null = null;
    private constructor() {
        this.initialize();
    }
    public static getInstance(): AuthorProfilePage {
        AuthorProfilePage.instance ??= new AuthorProfilePage();
        return AuthorProfilePage.instance;
    }
    private initialize(): void {
        const authorSection = document.querySelector(".author-section") as HTMLElement;
        if (!authorSection) return;
        const authorList = authorSection.querySelectorAll(".author-list-item");
        authorList.forEach((authorItem) => {
            const bioWrapper = authorItem.querySelector(".author-bio-wrapper") as HTMLElement;
            if (!bioWrapper) return;
            const bioBtn = bioWrapper.querySelector(".bio-btn") as HTMLInputElement;
            if (!bioBtn) return;
            const paragraph = bioWrapper.querySelector("div") as HTMLParagraphElement;
            if (!paragraph?.textContent) return;
            const lineHeight = Number.parseInt(window.getComputedStyle(paragraph).lineHeight);
            const totalHeight = paragraph.scrollHeight;
            if(lineHeight > 0 && totalHeight > 0) {
                const lineCount = Math.floor(totalHeight / lineHeight);
                if(lineCount <= 3) {
                    bioBtn.style.display = 'none';
                    return;
                }
                else{
                    bioBtn.style.display = 'flex';
                }
            }
            bioBtn.addEventListener("click", () => {
                this.showMoreLess(paragraph, bioBtn);
            });
        });
    }
    showMoreLess(paragraph: HTMLElement, bioBtn: HTMLElement): void{
        paragraph.classList.toggle('author-bio');
        let spanContent = bioBtn.querySelector('span');
        if(!spanContent){
            spanContent = document.createElement('span');
            spanContent.textContent = 'Show More';
            bioBtn.appendChild(spanContent);
        }
        if(paragraph.classList.contains('author-bio')){
            spanContent.textContent = 'Show More';
            bioBtn.classList.add('show-more');
            bioBtn.classList.remove('show-less');
        }
        else{
            spanContent.textContent = 'Show Less';
            bioBtn.classList.remove('show-more');
            bioBtn.classList.add('show-less');
        }
    }
}

if (!(globalThis as any).__AuthorProfileListenerAdded) {
    (globalThis as any).__AuthorProfileListenerAdded = true;
    document.addEventListener("DOMContentLoaded", () => {
        if ((globalThis as any).__AuthorProfileInitialized) return;
        // Initialize AuthorProfilePage if the author section exists
        if (document.querySelector(".author-section")) {
            (globalThis as any).__AuthorProfileInitialized = true;
            AuthorProfilePage.getInstance();
        }
    });
}
